<script>
import "./bootstrap-datepicker/bootstrap-datepicker.min.css"
import "./bootstrap-datepicker/bootstrap-datepicker.min.js"

export default {
  props: {
    name: String,
		value: [String],
		dateType: [String],
		config: Object,
		attr: Object,
  },
  data(){
    return {
      startdate: "",
      enddate: "",
    }
  },
  mounted: function () {
    setTimeout(()=>{ this.init() },100);
  },
  methods:{
    init(){
  		var option = {
				format: "dd-mm-yyyy",
        todayHighlight: true,
        toggleActive: true,
  			autoclose: true
  		}
      if(this.value) this.$emit('input', this.value)
  		$(this.$el).datepicker(Object.assign(option,this.config||{})).change((e)=>{
        this.$emit('input', this.val())
  		});
    },
    val(){
      return $(this.$el).find(".startdate").val()+" - "+$(this.$el).find(".enddate").val()
    }
  },
	watch: {
		value: function (v) {
      // if(!v) return $(this.$el).datepicker("update", "");
			// $(this.$el).datepicker("update", v)
		}
	}
}
</script>

<template>
  <div class="input-daterange input-group">
    <input type="text" class="form-control startdate" />
    <div class="input-group-append">
      <span class="input-group-text bg-info b-0 text-white">TO</span>
    </div>
    <input type="text" class="form-control enddate" />
    <input :name="name" type="hidden" v-model="value" v-bind="attr">
  </div>
</template>
